export default __webpack_public_path__ + "static/outlet_w.b566732733d8770e9f3c991c3da788bb.svg";